<template>
    <div class="index hml_whplt">
        <router-link class="homeBut" to="/index" tag="div">
            <img src="@/assets/img/secondLevelPage/home.gif" alt="">
        </router-link>
        <el-amap
        class="amap-box"
        :center="center"
        :zoom="zoom"
        ref="map"
        :events="events"
        :plugin="plugin"
        >
            <div v-if="mapInitState">
                <!-- 覆盖物 -->
                <el-amap-marker
                v-for="(item,index) in markers"
                :key="index"
                :position="item.position"
                :events="item.events"
                :zIndex="item.markerActive?101:100"
                >
                    <div
                    :class="['amapMarker1',{actiev: item.markerActive},item.gpsIndex != undefined?'amapMarker1_' + item.gpsIndex : '']"
                    @touchend="markerClick(index)"
                    v-if="bottomActiveIndex != -1 && bottomActiveIndex != 2">
                        <p>{{ item.title }}</p>
                    </div>
                    <div
                    :class="['amapMarker1',{actiev: item.markerActive},item.gpsIndex != undefined?'amapMarker1_' + item.gpsIndex : '']"
                    @touchend="markerClick(index)"
                    v-if="shouhuiFlag">
                        <p>{{ item.title }}</p>
                    </div>
                    <div :class="['amapMarker2',{actiev: item.markerActive}]" @touchend="markerClick(index)" v-if="leftActiveIndex != -1">
                        <div class="yuan">
                            <p>
                                <img :src="item.markerActive?leftlist[leftActiveIndex].url2:leftlist[leftActiveIndex].url1">
                            </p>
                        </div>
                    </div>
                    <div class="amapMarker3" v-if="bottomActiveIndex != -1 && bottomActiveIndex == 2">
                        <span>{{ index + 1 }}</span>
                        <h2>{{ item.title }}</h2>
                    </div>
                </el-amap-marker>
                <el-amap-polyline
                :editable="polyline.editable"
                :path="polyline.path"
                :events="polyline.events"
                strokeColor="#BFBFBF"
                ></el-amap-polyline>
            </div>
        </el-amap>
        <div class="domBox" v-if="mapInitState">
            <bottomList v-if="!shouhuiFlag"></bottomList>
            <leftList v-show="!isBriefIntroductionShow && bottomActiveIndex != 2 && !shouhuiFlag"></leftList>
            <briefIntroduction v-show="isBriefIntroductionShow && bottomActiveIndex != 2" @NavigationFun="NavigationFun"></briefIntroduction>
            <routeList v-if="bottomActiveIndex == 2" @listSlideClick="listSlideClick"></routeList>
            <div class="NavigationMode" v-show="NavigationModeState">
                <div class="content">
                    <div class="clone" @click="clone">
                        <img src="@/assets/img/map/MapClose.png">
                    </div>
                    <!-- <h2>请选择您要使用的地图</h2> -->
                    <ul>
                        <li
                        v-for="(item,index) in MapList"
                        :key="index"
                        @click="NavigationModeClick(index)"
                        >
                            <div class="left">
                                <img :src="item.url">
                                <div>
                                    <span>{{ item.title }}</span>
                                    <b>{{ item.httpUrl }}</b>
                                </div>
                            </div>
                            <div class="right"></div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="shouhui" @click="shouhuiClick">
                <img src="@/assets/img/map/shouhui1.png" v-if="!shouhuiFlag">
                <img src="@/assets/img/map/shouhui2.png" v-if="shouhuiFlag">
            </div>
        </div>
    </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const publicData = createNamespacedHelpers("publicData");
const mapData = createNamespacedHelpers("mapData");
import leftList from "@/components/map/leftList";
import bottomList from "@/components/map/bottomList";
import briefIntroduction from "@/components/map/briefIntroduction";
import routeList from "@/components/map/routeList";
export default {
    data() {
        return {  
            center: [113.118787,31.040669], // 默认中心点
            zoom: 12, // 默认缩放尺寸
            events: { // 地图事件
                init: (e) => {
                    this.mapInit(e);
                },
                click: (e) => {
                    this.mapClick(e);
                },
                zoomend: (e) => {
                    console.log(this.mapObj.getZoom());
                    if(this.shouhuiFlag){
                        if(this.mapObj.getZoom() < 10){
                            this.zoom = 10;
                            this.mapObj.setZoom(10);
                        }
                        if(this.mapObj.getZoom() > 14){
                            this.zoom = 14;
                            this.mapObj.setZoom(14);
                        }
                        if(this.mapObj.getZoom() < 12){
                            this.removeMarker();
                        }else{
                            let array = [];
                            array.push(...this.allData[2].dataArr[0].list,...this.allData[2].dataArr[1].list,...this.allData[2].dataArr[2].list,...this.allData[2].dataArr[3].list);
                            this.handleDataFun(array,1);
                        }
                    }
                    
                }
            },
            plugin: [ // 插件配置
                { // 放大缩小插件
                    pName: 'ToolBar', // 插件名称
                    position: "RT", // 插件位置
                }
            ],
            mapObj: null, // 地图对象
            mapInitState: false, // 地图初始化状态，为true初始化成功
            serviceData: [], // 服务数据 厕所加油站等
            markerRefs: [], // 点聚合数组
            markers: [], // 覆盖物数组
            cluster: null, // 点聚合对象
            polyline: { // 折线对象
                path: [], // gps数组
                events: {
                    click: () => {
                         // console.log("点击了折线");
                    },
                    end: (e) => {
                        let newPath = e.target.getPath().map(point => [point.lng, point.lat]);
                         // console.log(newPath);
                    }
                },
                editable: false,
            },
            NavigationModeState: false,
            MapList: [
				{
					url: require("@/assets/img/map/gaodeMap.png"),
                    title: "高德地图",
                    httpUrl: "https://www.amap.com/"
                },
                {
					url: require("@/assets/img/map/baiduMap.png"),
                    title: "百度地图",
                    httpUrl: "https://map.baidu.com"
				},
				{
					url: require("@/assets/img/map/tengxunMap.png"),
                    title: "腾讯地图",
                    httpUrl: "https://map.qq.com/"
				}
            ],
            shouhuiFlag: false,
            tileLayer: null,
            wxshareData: {
                title: "慢游京山",
                desc: "慢游京山",
                link: "http://www.hmltec.com/720/jingshan/index.html",
                imgUrl: "http://www.hmltec.com/720/jingshan/logo.png"
            },
        }
    },
    created(){
        this.handleserviceData();
    },
    methods: {
        shouhuiClick(){
            this.removeMarker();
            this.shouhuiFlag = !this.shouhuiFlag;
            if(this.shouhuiFlag){
                this.center = [113.110278,31.071676]
                this.mapObj.setZoom(10);
                this.cluster.setMinClusterSize(50);
                this.setLeftActiveIndex(-1);
                this.setBottomActiveIndex(-1);
                this.tileLayer.show();
                this.wxshareData.title = "京山旅游手绘地图";
                this.wxshareData.link = window.location.href.split("?")[0] + "?firstLevelIndex="+ this.firstLevelIndex +"&secondLevelIndex=" + 1 + "&levelThreeIndex=" + this.levelThreeIndex + "&url=/map";
            }else{
                this.tileLayer.show();
                this.cluster.setMinClusterSize(2);
                this.tileLayer.hide();
                this.wxshareData.title = "京山导览";
                this.wxshareData.link = window.location.href.split("?")[0] + "?firstLevelIndex="+ this.firstLevelIndex +"&secondLevelIndex=" + 0 + "&levelThreeIndex=" + this.levelThreeIndex + "&url=/map";
                
            }
            let wxshareData = this.wxshareData;
            wx.onMenuShareAppMessage({
                title: wxshareData.title, // 分享标题
                link: wxshareData.link, // 分享链接
                imgUrl: wxshareData.imgUrl, // 分享图标
                desc: wxshareData.desc, // 分享描述
                success () {
                    console.log("成功");
                },
                cancel () {
                    console.log("失败");
                }
            });
            wx.onMenuShareTimeline({
                title: wxshareData.title, // 分享标题
                link: wxshareData.link, // 分享链接
                imgUrl: wxshareData.imgUrl, // 分享图标
                desc: wxshareData.desc, // 分享描述
                success () {
                    console.log("成功");
                },
                cancel () {
                    console.log("失败");
                }
            })
            /* this.removeMarker();
            this.shouhuiFlag = !this.shouhuiFlag;
            console.log(this.shouhuiFlag);
            if(this.shouhuiFlag){
                this.cluster.setMinClusterSize(50);
                this.mapObj.setZoom(10);
                this.setLeftActiveIndex(-1);
                this.setBottomActiveIndex(-1);
                this.tileLayer.show();
                let array = [];
                array.push(...this.allData[2].dataArr[0].list,...this.allData[2].dataArr[1].list,...this.allData[2].dataArr[2].list,...this.allData[2].dataArr[3].list);
                this.handleDataFun(array);
            }else{
                this.cluster.setMinClusterSize(2);
                this.tileLayer.hide();
            } */
        },
        clone(){
            this.NavigationModeState = false;
        },
        NavigationFun(item){
            // this.NavigationModeState = true;
            // console.log(item);
            // const This = this;
            // let str = "";
            // str=`http://uri.amap.com/navigation?from=${This.detailedData.gps[1]},${This.detailedData.gps[0]},我的位置&to=${This.detailedData.gps[1]},${This.detailedData.gps[0]},${This.detailedData.title}&mode=car&policy=1&src=mypage&coordinate=gaode&callnative=0`;
            // // str=`http://api.map.baidu.com/marker?location=${This.detailedData.gps[1]},${This.detailedData.gps[0]}&title=${This.detailedData.title}&content=${This.detailedData.title}&output=html`;
            // window.location.href = str;
            // this.NavigationModeState = true;
            const This = this;
            console.log(This.detailedData);
            wx.openLocation({
                latitude: This.detailedData.gps[1],
                longitude: This.detailedData.gps[0],
                scale: 14,
                name: This.detailedData.title,
                address: This.detailedData.area,
                success () {
                        console.log("成功");
                    },
                    cancel () {
                        console.log("失败");
                    }
            })
        },
        onComplete(data){
             console.log('定位结果：' + data.position);
        },
        mapInit(e){ // 地图初始化函数
            /* const placeSearch = new AMap.PlaceSearch({ 
                pageSize: 50, // 单页显示结果条数
                pageIndex: 1, // 页码
                city: "京山", // 兴趣点城市
                citylimit: true,  //是否强制限制在设置的城市内搜索
                autoFitView: true, // 是否自动调整地图视野使绘制的 Marker点都处于视口的可见范围
            });
            
            // 公共厕所|荆门市京山市轻机大道463附近|113.130014,31.021736<br />
            placeSearch.search("加油站",(e,result) => {
                let str1 = "";
                result.poiList.pois.forEach(item => {
                    let {name,address,location} = item;
                    let str = name + "|" + address + "|" + location.lng + "," + location.lat;
                    str1+=str + "<br />";
                });
                console.log(str1);
            });
            placeSearch.search("厕所",(e,result) => {
                let str1 = "";
                result.poiList.pois.forEach(item => {
                    let {name,address,location} = item;
                    let str = name + "|" + address + "|" + location.lng + "," + location.lat;
                    str1+=str + "<br />";
                });
                console.log(str1);
            });
            placeSearch.search("停车场",(e,result) => {
                let str1 = "";
                result.poiList.pois.forEach(item => {
                    let {name,address,location} = item;
                    let str = name + "|" + address + "|" + location.lng + "," + location.lat;
                    str1+=str + "<br />";
                });
                console.log(str1);
            }); */
            const _this = this;
            const renderCluserMarker = this.renderCluserMarker;
            const markerRefs = this.markerRefs;
            this.mapObj = e; // 将地图对象存储起来
            this.mapInitState = true;
            // 创建点聚合对象
            this.cluster = new AMap.MarkerClusterer(e, this.markerRefs,{
                gridSize: 80,
                renderCluserMarker: renderCluserMarker,
                // averageCenter: true,
                maxZoom: 13,
            });
            let dataObj =  this.GetRequest();
            AMap.plugin('AMap.Geolocation', function() { 
                var geolocation = new AMap.Geolocation({
                    enableHighAccuracy: true,//是否使用高精度定位，默认:true
                    timeout: 10000,          //超过10秒后停止定位，默认：5s
                    buttonPosition:'RB',    //定位按钮的停靠位置
                    buttonOffset: new AMap.Pixel(10, 20),//定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
                    zoomToAccuracy: true,   //定位成功后是否自动调整地图视野到定位点
                });
                // e.addControl(geolocation);
                geolocation.getCurrentPosition(function(status,result){
                    if(status=='complete'){
                        _this.onComplete(result)
                    }else{
                        // onError(result)
                    }
                });
            });
            this.tileLayer = new AMap.TileLayer({
                map: e,
                tileSize: 256,
                tileUrl: "https://hmltec.oss-cn-beijing.aliyuncs.com/jingshan/staticState/tiles/[z]/tile-[x]_[y].png",
                zIndex: 100,
                opacity: 1,
                zooms: [3, 19],
            });
            this.tileLayer.hide();
            
            if(this.getIntoTheState == 2){
                setTimeout(() => {
                    this.zoom = 15;
                    let index = this.levelThreeIndex;
                    if(this.secondLevelIndex == 2 || this.secondLevelIndex == 3){
                        for(let i = 0; i < this.markers.length; i++){
                            if(this.markers[i].title == this.allData[this.firstLevelIndex].dataArr[this.secondLevelIndex].list[this.levelThreeIndex].title){
                                index = i;
                                break;
                            }
                        }
                    }
                    this.center = this.markers[index].position;
                    setTimeout(() => {
                        this.markerClick(index);
                    },200)
                },500);
            }
            let src = decodeURI(location.search); //获取url中"?"符后的字串
            let theRequest = new Object();
            if (src.indexOf("?") != -1) {
                let str = src.substr(1);
                let strs = str.split("&");
                for(let i = 0; i < strs.length; i ++) {
                    theRequest[strs[i].split("=")[0]]=unescape(strs[i].split("=")[1]);
                }
            }
            let { firstLevelIndex,secondLevelIndex,url } = theRequest;
            if(firstLevelIndex == 4 && secondLevelIndex == 1){
                this.shouhuiClick();
            }
            // console.log(this.mapObj);
            // console.log("地图初始化完成");
        },
        mapClick(e){ // 地图点击函数
            if(this.mapClickFlag){
                return;
            }
            this.briefIntroductionHide();
            let arrLength = this.markers.length;
            for(let i = 0; i < arrLength; i++){
                if(this.markers[i].markerActive){
                    this.markers[i].markerActive = false;
                    let obj = this.markers[i];
                    this.$set(this.markers,i,obj);
                    break;
                }
            }
        },
        markerClick(index){ // 覆盖物点击函数
            this.mapClickFlag = true;
            // console.log("点击了覆盖物",index);
            let arrLength = this.markers.length;
            for(let i = 0; i < arrLength; i++){
                if(this.markers[i].markerActive){
                    this.markers[i].markerActive = false;
                    break;
                }
            }
            this.markers[index].markerActive = true;
            let obj = this.markers[index];
            this.$set(this.markers,index,obj);
            this.setDetailedData(obj);
            this.briefIntroductionShow();
            setTimeout(() => {
                this.mapClickFlag = false;
            },300);
        },
        handleDataFun(array,flag=0){ // 处理gps数据函数
            // 插件机制，添加覆盖物需要在清除后延迟添加
            let arr = [];
            setTimeout(() => {
                array.forEach((item) => {
                    if(item.gps.length == 2){
                        item.position = item.gps;
                        item.markerActive = false;
                        item.events = {
                            init: (o) => {
                                this.markerRefs.push(o);
                            },
                            click: (e) => {
                                this.markerClick(index);
                            }
                        }
                        arr.push(item);
                    }
                    
                });
                this.addMarker(arr,flag);
            },100);
        },
        addMarker(array,flag=0){ // 添加覆盖物函数
            this.markers = array;
            const markerRefs = this.markerRefs;
            // console.log(this.markers,markerRefs);
            // 插件机制，添加覆盖物需要在清除后延迟添加
            setTimeout(() => {
                if(flag == 0){
                    this.center = this.markers[0].position;
                }
                this.cluster.addMarkers(markerRefs);
            },100);
        },
        removeMarker(){ // 清空覆盖物函数
            this.briefIntroductionHide();
            const markerRefs = this.markerRefs;
            if(this.cluster){
                this.cluster.removeMarkers(markerRefs);
            }
            this.markerRefs = []; // 清空点聚合数组
            this.markers = []; // 清空覆盖物数组
        },
        handleserviceData(){ // 处理服务数据
            let array1 = this.allData[4].dataArr[0].list;
            array1.forEach((item,index) => {
                if(item){
                    let arr = item.content.replace(/\n/g,"").split("<br />");
                    if(!this.serviceData[index]){
                        this.serviceData[index] = [];
                    }
                    arr.forEach((value,i) => {
                        if(value.length > 5){
                            this.serviceData[index].push({
                                title: value.split("|")[0],
                                addr: value.split("|")[1],
                                gps: [parseFloat(value.split("|")[2].split(",")[0]),parseFloat(value.split("|")[2].split(",")[1])],
                            });
                        }
                    });
                }
            });
            // console.log(this.serviceData);
        },
        renderCluserMarker(context){ // 自定义点聚合样式函数
            const count = this.markers.length;
             // console.log(count);
            let factor = Math.pow(context.count/count, 1/18);
             // console.log(factor);
            let div = document.createElement('div');
            let Hue = 180 - factor * 180;
            let bgColor = 'hsla('+Hue+',100%,50%,0.7)';
            let fontColor = 'hsla('+Hue+',100%,20%,1)';
            let borderColor = 'hsla('+Hue+',100%,40%,1)';
            let shadowColor = 'hsla('+Hue+',100%,50%,1)';
            // div.style.backgroundColor = "rgba(88,191,167,"+ factor +")";
            div.style.background = "url("+ require('@/assets/svg/map/markers.svg') +") no-repeat";
            div.style.backgroundSize = "100% 100%";
            let size = .63;
            div.style.width = div.style.height = size +'rem';
            // div.style.border = 'solid 1px '+ borderColor;
            div.style.borderRadius = "50%";
            // div.style.boxShadow = '0 0 1px '+ shadowColor;
            div.innerHTML = context.count;
            div.style.lineHeight = size +'rem';
            div.style.color = fontColor;
            div.style.fontSize = '14px';
            div.style.textAlign = 'center';
            context.marker.setOffset(new AMap.Pixel(-size/2,-size/2));
            context.marker.setContent(div)
        },
        listSlideClick(index){ // 路线列表点击事件
            this.polyline.path = [];
            let currentData = this.allData[2].dataArr[4].list[index];
            this.setDetailedData(currentData);
            // this.briefIntroductionShow();
            let arr = [];
            let str1 = currentData.content_2;
             // console.log(str1);
            str1.replace(/\n/g,"").split("<br />").forEach((item,i) => {
                if(item.length > 10){
                    let obj = {};
                    obj.title = item.split("#")[0];
                    obj.gps = [
                        parseFloat(item.split("#")[2].split(",")[0]),
                        parseFloat(item.split("#")[2].split(",")[1]),
                    ];
                    obj.index = i;
                    this.polyline.path.push(obj.gps);
                    arr.push(obj);
                }
            });
            this.handleDataFun(arr);
            // console.log(this.polyline.path);
            this.center = this.polyline.path[0];
        },
        ...mapData.mapMutations(["setBottomActiveIndex","setLeftActiveIndex","setDetailedData","setRightListState","briefIntroductionShow","briefIntroductionHide","routerdetailsShow","routerdetailsHide"]),
    },
    computed: {
        ...publicData.mapState(["allData","firstLevelIndex","secondLevelIndex","levelThreeIndex","getIntoTheState"]),
        ...mapData.mapState(["leftActiveIndex","bottomActiveIndex","rightListState","leftlist","isBriefIntroductionShow","detailedData"])
    },
    components: {
        leftList,
        bottomList,
        briefIntroduction,
        routeList
    },
    beforeDestroy(){
        this.setBottomActiveIndex(-1);
        this.setLeftActiveIndex(-1);
        this.setRightListState(-1);
        this.briefIntroductionHide();
    },
    watch: {
        leftActiveIndex(nv){
            
            if(this.markers.length > 0){
                this.removeMarker();
            }
            if(nv != -1){
                if(this.shouhuiFlag){
                    this.removeMarker();
                    this.shouhuiClick();
                }
                let array = this.serviceData[nv];
                this.handleDataFun(array);
            }
        },
        bottomActiveIndex(nv){
            
            if(this.markers.length > 0){
                this.removeMarker();
            }
            if(nv != -1){
                if(this.shouhuiFlag){
                    this.removeMarker();
                    this.shouhuiClick();
                }
                if(nv != 2){
                    this.polyline.path = [];
                }
                if(nv < 2){
                    let array = [];
                    if(nv == 0){
                        array.push(...this.allData[2].dataArr[0].list,...this.allData[2].dataArr[2].list,...this.allData[2].dataArr[3].list);
                    }else{
                        array.push(...this.allData[2].dataArr[1].list);
                    }
                    // let array = this.allData[2].dataArr[nv].list;
                    this.handleDataFun(array);
                }
            }else{
                this.polyline.path = [];
            }
        },
        rightListState(nv){
            console.log(nv);
            if(this.markers.length > 0){
                this.removeMarker();
            }
            let array = [];
            nv.forEach((item,index) => {
                if(item.flag){
                    console.log(this.allData[3].dataArr[index].list);
                    array.push(...this.allData[3].dataArr[index].list);
                }
            });
            if(array.length == 0){
                return;
            }
            this.handleDataFun(array);
        }
    },
}
</script>

<style lang="scss" scoped>
.shouhui{
    width: .92rem;
    height: .92rem;
    // background: #0cf;
    position: absolute;
    right: .4rem;
    top: .22rem;
}
.NavigationMode{
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,.5);
    position: absolute;
    left: 0;
    top: 0;
    z-index: 999;
    .content{
        width: 100%;
        height: 6.9rem;
        border-radius: .1rem;
        // box-shadow:0px .02rem .18rem 0px rgba(166,166,166,0.44);
        padding: .84rem .7rem 0;
        position: absolute;
        left: 50%;
        transform: translate(-50%,-50%);
        top: 40%;
        // h2{
        // 	font-size: .28rem;
        // 	color: #999;
        // 	text-align: center;
        // }
        .clone{
            width: .72rem;
            height: .72rem;
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            bottom: -.97 + -.72rem;
        }
        ul{
            width: 6rem;
            height: 100%;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;
            li{
                width: 100%;
                height: 1.8rem;
                overflow: hidden;
                padding: .3rem .3rem .4rem .34rem;
                background: #fff;
                border-radius: .1rem;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .left{
                    display: flex;
                    align-items: center;
                    img{
                        width: 1.1rem;
                        height: 1.1rem;
                        box-shadow:0px .04rem .06rem 0px rgba(36,36,36,0.2);
                        border-radius: .2rem;
                    }
                    div{
                        display: flex;
                        flex-direction: column;
                        margin-left: .4rem;
                        span{
                            font-size: .3rem;
                            color: #333;
                            font-weight: bold;
                        }
                        b{
                            color: #999;
                            font-size: .24rem;
                            margin-top: .24rem;
                        }
                    }
                }
                .right{
                    height: .2rem;
                    width: .2rem;
                    border-width: 0 .04rem .04rem 0;
                    border-color: #D2D2D2;
                    border-style: solid;
                    transform: matrix(0.71, 0.71, -.71, 0.71, 0, 0) rotate(-90deg);
                }
                
            }
        }
    }
}
.mapBg{
    width: 80%;
    height: auto;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    z-index: 100;
    // display: none;
}
.customBox{
    background: url() no-repeat;
    .bottomList{
        width: 6.9rem;
        height: 1.24rem;
        background: #fff;
        border-radius: .1rem;
        position: absolute;
        left: 50%;
        bottom: .64rem;
        transform: translateX(-50%);
        box-shadow:0rem .08rem .08rem 0rem rgba(50,50,50,0.2);
        display: flex;
        align-items: center;
        li{
            flex: 1;
            height: 1.24rem;
            font-size: .4rem;
            color: #333;
            display: flex;
            align-items: center;
            justify-content: center;
            &.active{
                color: #0fc;
            }
        }
    }
}
.homeBut{
    width: .7rem;
    height: .7rem;
    // background: #fff;
    position: absolute;
    left: 0;
    top: 0;
    padding: .14rem .24rem .08rem;
    padding-right: 0;
    box-sizing: content-box;
    z-index: 10;
}
.amap-box{
    /deep/.search-tips{
        font-size: .24rem;
    }
    /deep/.amap-demo {
      height: 300px;
    }

    /deep/.search-box {
      position: absolute;
      top: 25px;
      left: 20px;
    }
    /deep/.search-btn{
        font-size: .24rem;
    }
    /deep/.amap-page-container {
      position: relative;
    }
    /deep/.amap-logo{
        display: none !important;
    }
    /deep/.amap-copyright{
        display: none !important;
    }
    /deep/.amapMarker3{
        width: .4rem;
        height: .4rem;
        background:rgba(66,66,66,.2);
        border-radius: 50%;
        position: absolute;
        left: 0;
        top: 0;
        transform: translate(0%,90%);
        font-size: .2rem;
        color: #fff;
        h2{
            height: .42rem;
            position: absolute;
            left: .42rem;
            top: 50%;
            transform: translateY(-50%);
            font-size: .28rem;
            color: #333;
            padding: 0 .12rem;
            border-radius: .21rem;
            background: #fff;
            border: .02rem solid #000;
            white-space: nowrap;
            line-height: .42rem;
        }
        span{
            z-index: 1;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        &::after,span{
            content: "";
            width: .3rem;
            height: .3rem;
            border-radius: 50%;
            background: #424242;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%,-50%);
        }
    }
    /deep/.amapMarker2{
        position: absolute;
        left: 0;
        top: 0;
        width: 0;
        height: 0;
        border-left: .14rem solid transparent;
        border-right: .14rem solid transparent;
        border-top: .22rem solid #3E3E3E;
        .yuan{
            width: .64rem;
            height: .64rem;
            border-radius: 50%;
            background: #3E3E3E;
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            top: -.83rem;
            display: flex;
            align-items: center;
            justify-content: center;
            p{
                width: .36rem;
                height: .36rem;
                background: #fff;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                img{
                    width: 80%;
                }
            }
        }
        &.actiev{
            border-left: .2rem solid transparent;
            border-right: .2rem solid transparent;
            border-top: .28rem solid #70DBCA;
            transition: all .2s ease;
            .yuan{
                width: 1.02rem;
                height: 1.02rem;
                top: -1.25rem;
                background:linear-gradient(-30deg,rgba(112,219,202,1),rgba(88,191,167,1));
                transition: all .2s ease;
                p{
                    width: .6rem;
                    height: .6rem;
                    transition: all .2s ease;
                }
            }
        }
    }
    /deep/.amapMarker1{
        width:0;
        height:0;
        border-right: .12rem solid transparent;
        border-left: .12rem solid transparent;
        border-top: .12rem solid #424242;
        position: absolute;
        left: 0;
        bottom: 0rem;
        transition: all .2s ease;
        p{
            width: auto;
            position: absolute;
            left: 50%;
            top: -.54rem;
            transform: translateX(-50%);
            padding: 0 .2rem;
            height: .44rem;
            border-radius: 0.22rem;
            background: #424242;
            font-size: .22rem;
            color: #fff;
            line-height: .44rem;
            white-space: nowrap;
            display: flex;
            align-items: center;
            transition: all .2s ease;
            img{
                margin-right: .06rem;
            }
        }
        &.amapMarker1_0,&.amapMarker1_1,&.amapMarker1_2{
            &.actiev{
                border-top: .12rem solid #424242;
                p{
                    background: #424242;
                }
            }
        }
        &.amapMarker1_0{
            border-top: .12rem solid #A378FF;
            p{
                background: #A378FF;
            }
        }
        &.amapMarker1_1{
            border-top: .12rem solid #FE8223;
            p{
                background: #FE8223;
            }
        }
        &.amapMarker1_2{
            border-top: .12rem solid #FFB200;
            p{
                background: #FFB200;
            }
        }
        &.actiev{
            border-top: .12rem solid #70DBCA;
            p{
                // border-top: .12rem solid linear-gradient(0deg,rgba(112,219,202,1) 0%,rgba(88,191,167,1) 100%);
                background:linear-gradient(0deg,rgba(112,219,202,1) 0%,rgba(88,191,167,1) 100%);
            }
        }
    }
}
</style>
